import EventBus from "@/eventBus";
import { constants } from "@/utils/generic";

let callNums = 0;
let isRefreshingToken = false;
let isRefreshTokenCompleteResolve;
let isRefreshTokenCompleteReject;

const isRefreshTokenComplete = new Promise(function(resolve, reject){
  isRefreshTokenCompleteResolve = resolve;
  isRefreshTokenCompleteReject = reject;
});

const interceptorFetch = (...args) =>
  (async (args) => {
    try {
      if (args[0].includes('Clients/refreshTokens')) {
        isRefreshingToken = true;
        const refreshRes = await fetch(...args);
        // if the refresh token call fails, logout
        if (refreshRes.status === 401 || refreshRes.status === 400) {
          localStorage.removeItem(constants.IS_LOGGED_USER_LK);
          EventBus.$emit("unauthorized");
          isRefreshTokenCompleteReject();
        } else {
          // For performance purpose, js lets you read from ReadableStream only one time
          // so we need to clone the result in order to get the data from the vue store
          // (in particular, in the "refreshToken" action of the login.js).
          // Refer to: https://github.com/whatwg/fetch/issues/196
          const jsonRes = await refreshRes.clone().json();
          isRefreshTokenCompleteResolve(jsonRes.accessToken);
        }
        isRefreshingToken = false;
        return refreshRes;
      }

      return await execApiCall(args);
    } catch (err) {
      --callNums;
      if (!callNums) EventBus.$emit("showSpinner", false);
      console.log(err);
    }
  })(args);

const execApiCall = async (args) => {
  if (!callNums) EventBus.$emit("showSpinner", true);
  ++callNums;
  const result = await fetch(...args);
  --callNums;
  if (!callNums && !EventBus.keepSpinner) EventBus.$emit("showSpinner", false);

  // if the api call fails with "unauthorized", try to refresh the token 
  if (
    !window.location.href.includes("login") &&
    result.status === 401 &&
    (!result.error ||
      !result.error.code ||
      result.error.code !== "LOGIN_FAILED")
  ) {
    if (!isRefreshingToken) EventBus.$emit("refreshToken");
    const accessToken = await isRefreshTokenComplete;
    args[1].headers.Authorization = accessToken; // update the access token on the current api call
    args[2] = (args[2] || 0) + 1; // args[2] will contain the retry calls
    return args[2] > 3 ? result : await execApiCall(args); // max 3 retry calls
  }

  return result;
}

const get = async (url, token, recaptcha) => {
  const tokenHeader = token
    ? {
      headers: {
        Authorization: token,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    }
    : {headers : {}};
  if(recaptcha) tokenHeader.headers.Recaptcha = recaptcha;
  const response = await interceptorFetch(url, tokenHeader);

  return response.json();
};

const post = async (endpoint = "", data = {}, token = "") => {
  const response = await interceptorFetch(endpoint, {
    method: "POST",
    headers: {
      Authorization: token,
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  try {
    const text = await response.text(); // Parse it as text
    return JSON.parse(text); // Try to parse it as json
  } catch (err) {
    console.log(err);
  }
};
const patch = async (endpoint = "", data = {}, token = "") => {
  const response = await interceptorFetch(endpoint, {
    method: "PATCH",
    headers: {
      Authorization: token,
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  try {
    const text = await response.text(); // Parse it as text
    return JSON.parse(text); // Try to parse it as json
  } catch (err) {
    // NO RESPONSE
  }
};
const put = async (endpoint = "", data = {}, token = "") => {
  const response = await interceptorFetch(endpoint, {
    method: "PUT",
    headers: {
      Authorization: token,
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  try {
    const text = await response.text(); // Parse it as text
    return JSON.parse(text); // Try to parse it as json
  } catch (err) {
    // NO RESPONSE
  }
};

export { get, post, patch, put };
